import React, { useState, useEffect } from "react";

function TypingGame() {
  const words = [
    "Goa",
    "Pune",
    "Ooty",
    "Delhi",
    "Mumbai",
    "Jaipur",
    "Chennai",
    "Kolkata",
    "Bengaluru",
    "Hyderabad",
  ];

  const [index, setIndex] = useState(0);
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [correctWords, setCorrectWords] = useState([]);
  const [secondsLeft, setSecondsLeft] = useState(5);

  // main interval to change word every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev < words.length - 1 ? prev + 1 : 0));
      setMessage("");
      setInput("");
      setSecondsLeft(5);
    }, 5000);
    return () => clearInterval(interval);
  }, [words.length]);

  // countdown timer for UI
  useEffect(() => {
    // reset when index changes
    setSecondsLeft(5);
  }, [index]);

  useEffect(() => {
    const tick = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(tick);
  }, [index]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);

    if (value.toLowerCase() === words[index].toLowerCase()) {
      setMessage("Great Skill! 🎉");
      if (!correctWords.includes(words[index])) {
        setCorrectWords((prev) => [...prev, words[index]]);
      }
    } else {
      // only show "keep typing" while typing
      setMessage(value ? "Keep typing..." : "");
    }
  };

  const progressPercent = Math.round((secondsLeft / 5) * 100);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-sky-300 via-indigo-300 to-pink-300 p-6">
      <div className="w-full max-w-xl bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6">
        <h2 className="text-2xl font-extrabold text-gray-800 mb-2 text-center">
          ✍️ Typing Game
        </h2>

        <p className="text-center text-sm text-gray-600 mb-4">
          Type the word before it changes. Next word appears every <b>5s</b>.
        </p>

        <div className="bg-gradient-to-r from-white/60 to-white/30 rounded-lg p-4 shadow-inner mb-4">
          <div className="flex items-center justify-between mb-3">
            <div className="text-lg font-semibold text-gray-700">Current word</div>
            <div className="text-sm text-gray-500">Time left: {secondsLeft}s</div>
          </div>

          <div className="flex items-center justify-center mb-4">
            <div className="px-6 py-3 rounded-lg text-xl font-bold text-gray-900 bg-white/60 border border-gray-200 shadow-sm">
              {words[index]}
            </div>
          </div>

          <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-300"
              style={{ width: `${progressPercent}%`, background: "linear-gradient(90deg,#34d399,#60a5fa)" }}
            />
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 mb-4">
          <input
            value={input}
            onChange={handleInputChange}
            placeholder="Enter the word here"
            className={`w-full px-4 py-3 rounded-lg text-lg font-medium outline-none transition-all
              ${message.includes("Great") ? "ring-4 ring-green-200 border-2 border-green-400" : "ring-0 border border-gray-200"} `}
          />

          <p className={`text-sm font-medium ${message.includes("Great") ? "text-green-700" : "text-gray-600"}`}>
            {message}
          </p>
        </div>

        {correctWords.length > 0 && (
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Correct Words</h3>
            <div className="flex flex-wrap gap-2">
              {correctWords.map((w, i) => (
                <span
                  key={i}
                  className="px-3 py-1 rounded-full bg-gradient-to-r from-green-200 to-green-300 text-sm font-medium text-green-800 shadow-sm"
                >
                  {w}
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-between items-center mt-4">
          <div className="text-xs text-gray-500">Words practiced: {correctWords.length}</div>
          <button
            onClick={() => {
              setCorrectWords([]);
              setMessage("");
            }}
            className="px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:shadow-md text-sm"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
}

export default TypingGame;
